export const numberFormatter = (n = 0) => n.toFixed(2);
